import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";
import companyReducer from "./slices/app/companySlice";
import authReducer from "./slices/auth/authSlice";
import { i18nInitAction } from "./slices/common/i18n/i18nInitAction";
import i18nReducer from "./slices/common/i18n/i18nSlice";
import { dumpLayoutToStorage, handleBodyClasses, layoutInit, layoutReducer } from "./slices/common/layout";
import { navigationInitAction } from "./slices/common/navigation/navigationInitAction";
import navigationReducer from "./slices/common/navigation/navigationSlice";

const rootReducer = combineReducers({
  layout: layoutReducer,
  i18n: i18nReducer,
  navigation: navigationReducer,
  auth: authReducer,
  company: companyReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(handleBodyClasses)
      .concat(dumpLayoutToStorage),
});

store.dispatch(layoutInit());
store.dispatch(i18nInitAction());
store.dispatch(navigationInitAction());

export const persistor = persistStore(store);

export default store;
